import { Header } from 'modules/minimal-ui-theme';
import { BackButton } from './BackButton';

interface Props {
  title?: string;
  subtitle?: string;
  withBackBtn?: boolean;
}

export const PageHeader = ({ title, subtitle, withBackBtn }: Props) => (
  <Header
    title={title ?? ''}
    subTitle={subtitle}
    buttonLeft={withBackBtn ? <BackButton /> : undefined}
  />
);
